import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { makeStyles } from "@material-ui/core/styles";
import FilterListIcon from "@material-ui/icons/FilterList";

import TicketsManager from "../../components/TicketsManager/";
import Ticket from "../../components/Ticket/";

import { i18n } from "../../translate/i18n";
import Hidden from "@material-ui/core/Hidden";
import api from "../../services/api";
import toastError from "../../errors/toastError";
import openSocket from "../../services/socket-io";
import { AuthContext } from "../../context/Auth/AuthContext";

const useStyles = makeStyles((theme) => ({
  chatContainer: {
    flex: 1,
    // // backgroundColor: "#eee",
    // padding: theme.spacing(4),
    height: `calc(100% - 48px)`,
    overflowY: "hidden",
    backgroundColor: theme.palette.background.default,
  },

  chatPapper: {
    // backgroundColor: "red",
    display: "flex",
    flexDirection: "column",
    height: "100%",
    backgroundColor: theme.palette.background.paper,
  },
  ticketsGrid: {
    flex: 1,
    minHeight: 0,
    flexWrap: "initial",
    overflow: "auto",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      display: "flex",
      boxSizing: "border-box",
      flexDirection: "column",
    },
  },

  contactsWrapper: {
    display: "flex",
    flexDirection: "column",
    overflowY: "initial",
    borderRight: "solid 1px rgba(0, 0, 0, .1)",
    [theme.breakpoints.down("sm")]: {
      flexGrow: 0,
      maxWidth: "100%",
      flexBasis: "auto",
      width: "100%",
    },
  },
  contactsWrapperSmall: {
    display: "flex",
    flexDirection: "column",
    overflowY: "initial",
    borderRight: "solid 1px rgba(0, 0, 0, .1)",
    [theme.breakpoints.down("sm")]: {
      display: "none",
      flexGrow: 0,
      maxWidth: "100%",
      flexBasis: "auto",
      width: "100%",
    },
  },
  messagessWrapper: {
    display: "flex",
    height: "100%",
    flexDirection: "column",
    [theme.breakpoints.down("sm")]: {
      flexGrow: 0,
      maxWidth: "100%",
      flexBasis: "auto",
      width: "100%",
    },
  },
  welcomeMsg: {
    backgroundColor: "#f7f5f3",
    display: "flex",
    justifyContent: "space-evenly",
    alignItems: "center",
    height: "100%",
    textAlign: "center",
    borderRadius: 0,
  },
  ticketsManager: {},
  ticketsManagerClosed: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  labelQuickFilterBar: {
    flex: "none",
    display: "flex",
    alignItems: "center",
    gap: 6,
    width: "100%",
    padding: theme.spacing(0.75, 0.5),
    overflowX: "auto",
    overflowY: "hidden",
    backgroundColor: theme.palette.background.default,
    borderBottom: `1px solid ${theme.palette.divider}`,
    ...theme.scrollbarStyles,
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  labelFilterIcon: {
    flex: "0 0 auto",
    width: 36,
    height: 32,
    padding: 0,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 10,
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.secondary,
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
  },
  funnelQuickFilterSelect: {
    flex: "0 0 180px",
    minWidth: 180,
    backgroundColor: theme.palette.background.paper,
  },
  labelQuickFilterButton: {
    flex: "0 0 auto",
    height: 32,
    maxWidth: 180,
    border: "2px solid",
    borderRadius: 10,
    boxSizing: "border-box",
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    padding: "0 7px 0 10px",
    fontWeight: 700,
    fontSize: 13,
    whiteSpace: "nowrap",
    transition: "background-color 160ms ease, border-color 160ms ease, transform 160ms ease",
    "&:hover": {
      transform: "translateY(-1px)",
    },
  },
  labelQuickFilterName: {
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  labelQuickFilterCount: {
    minWidth: 22,
    height: 22,
    borderRadius: 999,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0 6px",
    color: "#fff",
    fontSize: 12,
    fontWeight: 800,
    boxShadow: "0 2px 5px rgba(0, 0, 0, 0.18)",
  },
}));

const hexToRgba = (hex, alpha) => {
  if (!hex || typeof hex !== "string") return `rgba(25, 118, 210, ${alpha})`;

  const normalized = hex.replace("#", "");
  if (![3, 6].includes(normalized.length)) {
    return `rgba(25, 118, 210, ${alpha})`;
  }

  const fullHex =
    normalized.length === 3
      ? normalized
          .split("")
          .map(char => `${char}${char}`)
          .join("")
      : normalized;

  const value = Number.parseInt(fullHex, 16);
  const red = (value >> 16) & 255;
  const green = (value >> 8) & 255;
  const blue = value & 255;

  return `rgba(${red}, ${green}, ${blue}, ${alpha})`;
};

const getReadableTextColor = color => {
  const hex = (color || "#ffffff").replace("#", "");
  const normalized =
    hex.length === 3
      ? hex.split("").map(char => `${char}${char}`).join("")
      : hex.padEnd(6, "f").slice(0, 6);
  const red = parseInt(normalized.slice(0, 2), 16);
  const green = parseInt(normalized.slice(2, 4), 16);
  const blue = parseInt(normalized.slice(4, 6), 16);
  const luminance = (red * 299 + green * 587 + blue * 114) / 1000;

  return luminance > 150 ? "#243040" : "#ffffff";
};

const darkenHexColor = (hex, amount = 0.38) => {
  if (!hex || typeof hex !== "string") return "#243040";

  const normalized = hex.replace("#", "");
  if (![3, 6].includes(normalized.length)) return "#243040";

  const fullHex =
    normalized.length === 3
      ? normalized
          .split("")
          .map(char => `${char}${char}`)
          .join("")
      : normalized;

  const value = Number.parseInt(fullHex, 16);
  const red = (value >> 16) & 255;
  const green = (value >> 8) & 255;
  const blue = value & 255;

  return `rgb(${Math.round(red * (1 - amount))}, ${Math.round(
    green * (1 - amount)
  )}, ${Math.round(blue * (1 - amount))})`;
};

const getEnhancedFilterColor = hex => {
  if (!hex || typeof hex !== "string") return "#1976d2";

  const normalized = hex.replace("#", "");
  if (![3, 6].includes(normalized.length)) return "#1976d2";

  const fullHex =
    normalized.length === 3
      ? normalized
          .split("")
          .map(char => `${char}${char}`)
          .join("")
      : normalized;

  const value = Number.parseInt(fullHex, 16);
  let red = ((value >> 16) & 255) / 255;
  let green = ((value >> 8) & 255) / 255;
  let blue = (value & 255) / 255;

  const max = Math.max(red, green, blue);
  const min = Math.min(red, green, blue);
  let hue = 0;
  let saturation = 0;
  let lightness = (max + min) / 2;
  const delta = max - min;

  if (delta) {
    saturation = lightness > 0.5
      ? delta / (2 - max - min)
      : delta / (max + min);

    if (max === red) {
      hue = (green - blue) / delta + (green < blue ? 6 : 0);
    } else if (max === green) {
      hue = (blue - red) / delta + 2;
    } else {
      hue = (red - green) / delta + 4;
    }

    hue /= 6;
  }

  saturation = Math.min(0.82, Math.max(0.34, saturation + 0.28));
  lightness = Math.min(0.58, Math.max(0.34, lightness - 0.18));

  const hueToRgb = (p, q, t) => {
    let nextT = t;
    if (nextT < 0) nextT += 1;
    if (nextT > 1) nextT -= 1;
    if (nextT < 1 / 6) return p + (q - p) * 6 * nextT;
    if (nextT < 1 / 2) return q;
    if (nextT < 2 / 3) return p + (q - p) * (2 / 3 - nextT) * 6;
    return p;
  };

  if (!saturation) {
    red = lightness;
    green = lightness;
    blue = lightness;
  } else {
    const q = lightness < 0.5
      ? lightness * (1 + saturation)
      : lightness + saturation - lightness * saturation;
    const p = 2 * lightness - q;
    red = hueToRgb(p, q, hue + 1 / 3);
    green = hueToRgb(p, q, hue);
    blue = hueToRgb(p, q, hue - 1 / 3);
  }

  return `#${[red, green, blue]
    .map(value =>
      Math.round(value * 255)
        .toString(16)
        .padStart(2, "0")
    )
    .join("")}`;
};

const normalizeFunnels = funnels => {
  if (!Array.isArray(funnels)) return [];

  return funnels.map(funnel => ({
    id: funnel.id,
    name: funnel.name || "Embudo",
    stages: Array.isArray(funnel.stages) ? funnel.stages : [],
    ticketStages: (funnel.tickets || []).reduce((acc, item) => {
      acc[String(item.ticketId)] = item.stageId;
      return acc;
    }, {}),
  }));
};

const Chat = () => {
  const classes = useStyles();
  const { ticketId } = useParams();
  const { user } = useContext(AuthContext);
  const filterStorageKey = `ticketQuickFilter:${user?.id || "default"}`;
  const getStoredFilter = () => {
    try {
      return JSON.parse(localStorage.getItem(filterStorageKey) || "{}");
    } catch (err) {
      return {};
    }
  };
  const [labels, setLabels] = useState([]);
  const [funnels, setFunnels] = useState([]);
  const [filterMode, setFilterMode] = useState(() => {
    const storedFilter = getStoredFilter();
    return ["labels", "funnels"].includes(storedFilter.mode)
      ? storedFilter.mode
      : "labels";
  });
  const [filterModeAnchorEl, setFilterModeAnchorEl] = useState(null);
  const [selectedLabelIds, setSelectedLabelIds] = useState(() => {
    const storedFilter = getStoredFilter();
    return Array.isArray(storedFilter.labelIds) ? storedFilter.labelIds : [];
  });
  const [selectedFunnelId, setSelectedFunnelId] = useState(() => {
    const storedFilter = getStoredFilter();
    return storedFilter.funnelId || "";
  });
  const [selectedFunnelStageId, setSelectedFunnelStageId] = useState(() => {
    const storedFilter = getStoredFilter();
    return storedFilter.stageId || "";
  });
  const [filterRefreshToken, setFilterRefreshToken] = useState(0);

  const loadLabels = useCallback(async () => {
    try {
      const { data } = await api.get("/labels");
      setLabels(data || []);
    } catch (err) {
      toastError(err);
    }
  }, []);

  const loadFunnels = useCallback(async () => {
    try {
      const { data } = await api.get("/funnels");
      const loadedFunnels = normalizeFunnels(data.funnels || []);
      setFunnels(loadedFunnels);
      setSelectedFunnelId(prevState =>
        loadedFunnels.some(funnel => String(funnel.id) === String(prevState))
          ? prevState
          : loadedFunnels[0]?.id || ""
      );
    } catch (err) {
      toastError(err);
    }
  }, []);

  useEffect(() => {
    loadLabels();
    loadFunnels();
  }, [loadLabels, loadFunnels]);

  useEffect(() => {
    localStorage.setItem(
      filterStorageKey,
      JSON.stringify({
        mode: filterMode,
        labelIds: selectedLabelIds,
        funnelId: selectedFunnelId,
        stageId: selectedFunnelStageId,
      })
    );
  }, [
    filterMode,
    filterStorageKey,
    selectedLabelIds,
    selectedFunnelId,
    selectedFunnelStageId,
  ]);

  const selectedFunnel = useMemo(
    () => funnels.find(funnel => String(funnel.id) === String(selectedFunnelId)),
    [funnels, selectedFunnelId]
  );

  const activeFunnelStageId = useMemo(() => {
    if (filterMode !== "funnels" || !selectedFunnelStageId) return "";

    return (selectedFunnel?.stages || []).some(
      stage => String(stage.id) === String(selectedFunnelStageId)
    )
      ? selectedFunnelStageId
      : "";
  }, [filterMode, selectedFunnel, selectedFunnelStageId]);

  useEffect(() => {
    if (
      selectedFunnelStageId &&
      !(selectedFunnel?.stages || []).some(
        stage => String(stage.id) === String(selectedFunnelStageId)
      )
    ) {
      setSelectedFunnelStageId("");
    }
  }, [selectedFunnel, selectedFunnelStageId]);

  useEffect(() => {
    const socket = openSocket();

    socket.on("connect", () => {
      socket.emit("joinNotification");
    });

    socket.on("ticket", data => {
      if (["update", "delete"].includes(data.action)) {
        loadLabels();
      }
    });

    socket.on("label", data => {
      if (["create", "update", "delete"].includes(data.action)) {
        loadLabels();
      }
    });

    socket.on("funnel", data => {
      if (
        ["create", "update", "delete", "stage:create", "stage:update", "stage:delete"].includes(
          data.action
        )
      ) {
        loadFunnels();
      }

      if (data.action === "ticket:move") {
        loadFunnels();
        setFilterRefreshToken(prevState => prevState + 1);
      }
    });

    return () => {
      socket.disconnect();
    };
  }, [loadLabels, loadFunnels]);

  const handleFilterModeChange = mode => {
    setFilterMode(mode);
    setFilterModeAnchorEl(null);

    if (mode === "labels") {
      setSelectedFunnelStageId("");
      return;
    }

    setSelectedLabelIds([]);
    if (!selectedFunnelId && funnels.length) {
      setSelectedFunnelId(funnels[0].id);
    }
  };

  const handleQuickLabelFilter = labelId => {
    setSelectedLabelIds(prevState =>
      prevState.includes(labelId) ? [] : [labelId]
    );
  };

  const handleQuickFunnelStageFilter = stageId => {
    setSelectedFunnelStageId(prevState =>
      String(prevState) === String(stageId) ? "" : stageId
    );
  };

  const renderLabelQuickFilters = () =>
    (!!labels.length || !!funnels.length) && (
      <div className={classes.labelQuickFilterBar}>
        <button
          type="button"
          className={classes.labelFilterIcon}
          title={filterMode === "labels" ? "Filtro de etiquetas" : "Filtro de embudo"}
          onClick={event => setFilterModeAnchorEl(event.currentTarget)}
        >
          <FilterListIcon fontSize="small" />
        </button>
        <Menu
          anchorEl={filterModeAnchorEl}
          keepMounted
          open={Boolean(filterModeAnchorEl)}
          onClose={() => setFilterModeAnchorEl(null)}
        >
          <MenuItem
            selected={filterMode === "labels"}
            onClick={() => handleFilterModeChange("labels")}
          >
            Etiquetas
          </MenuItem>
          <MenuItem
            selected={filterMode === "funnels"}
            onClick={() => handleFilterModeChange("funnels")}
          >
            Embudo
          </MenuItem>
        </Menu>
        {filterMode === "funnels" && (
          <FormControl
            className={classes.funnelQuickFilterSelect}
            margin="dense"
            size="small"
            variant="outlined"
          >
            <InputLabel>Embudo</InputLabel>
            <Select
              value={selectedFunnelId}
              label="Embudo"
              onChange={event => {
                setSelectedFunnelId(event.target.value);
                setSelectedFunnelStageId("");
              }}
            >
              {funnels.map(funnel => (
                <MenuItem key={funnel.id} value={funnel.id}>
                  {funnel.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
        {filterMode === "labels" && labels.map(label => {
          const selected = selectedLabelIds.includes(label.id);
          const labelColor = label.color || "#90a4ae";
          const enhancedColor = getEnhancedFilterColor(labelColor);
          const ticketCount = Number(label.ticketCount || 0);
          const selectedTextColor = getReadableTextColor(enhancedColor);

          return (
            <button
              key={label.id}
              type="button"
              className={classes.labelQuickFilterButton}
              onClick={() => handleQuickLabelFilter(label.id)}
              title={label.name}
              style={{
                borderColor: enhancedColor,
                color: selected ? selectedTextColor : undefined,
                backgroundColor: selected
                  ? enhancedColor
                  : hexToRgba(enhancedColor, 0.18),
                boxShadow: selected
                  ? `0 0 0 2px ${hexToRgba(enhancedColor, 0.28)}`
                  : undefined,
                transform: selected ? "translateY(-1px)" : undefined
              }}
            >
              <span className={classes.labelQuickFilterName}>
                {label.name}
              </span>
              <span
                className={classes.labelQuickFilterCount}
                style={{
                  backgroundColor: selected
                    ? selectedTextColor
                    : hexToRgba(enhancedColor, 0.24),
                  color: selected ? enhancedColor : darkenHexColor(enhancedColor, 0.18)
                }}
              >
                {ticketCount}
              </span>
            </button>
          );
        })}
        {filterMode === "funnels" && (selectedFunnel?.stages || []).map(stage => {
          const selected = String(selectedFunnelStageId) === String(stage.id);
          const stageColor = stage.color || "#90a4ae";
          const enhancedColor = getEnhancedFilterColor(stageColor);
          const ticketCount = Object.values(selectedFunnel.ticketStages || {}).filter(
            stageId => String(stageId) === String(stage.id)
          ).length;
          const selectedTextColor = getReadableTextColor(enhancedColor);

          return (
            <button
              key={stage.id}
              type="button"
              className={classes.labelQuickFilterButton}
              onClick={() => handleQuickFunnelStageFilter(stage.id)}
              title={stage.name}
              style={{
                borderColor: enhancedColor,
                color: selected ? selectedTextColor : undefined,
                backgroundColor: selected
                  ? enhancedColor
                  : hexToRgba(enhancedColor, 0.18),
                boxShadow: selected
                  ? `0 0 0 2px ${hexToRgba(enhancedColor, 0.28)}`
                  : undefined,
                transform: selected ? "translateY(-1px)" : undefined
              }}
            >
              <span className={classes.labelQuickFilterName}>
                {stage.name}
              </span>
              <span
                className={classes.labelQuickFilterCount}
                style={{
                  backgroundColor: selected
                    ? selectedTextColor
                    : hexToRgba(enhancedColor, 0.24),
                  color: selected ? enhancedColor : darkenHexColor(enhancedColor, 0.18)
                }}
              >
                {ticketCount}
              </span>
            </button>
          );
        })}
      </div>
    );

  return (
    <div className={classes.chatContainer}>
      <div className={classes.chatPapper}>
        {renderLabelQuickFilters()}
        <Grid container spacing={0} className={classes.ticketsGrid}>
          {/* <Grid item xs={4} className={classes.contactsWrapper}> */}
          <Grid
            item
            xs={12}
            md={4}
            className={
              ticketId ? classes.contactsWrapperSmall : classes.contactsWrapper
            }
          >
            <TicketsManager
              labels={labels}
              selectedLabelIds={filterMode === "labels" ? selectedLabelIds : []}
              setSelectedLabelIds={setSelectedLabelIds}
              selectedFunnelId={activeFunnelStageId ? selectedFunnelId : ""}
              selectedFunnelStageId={activeFunnelStageId}
              refreshToken={filterRefreshToken}
            />
          </Grid>
          <Grid item xs={12} md={8} className={classes.messagessWrapper}>
            {/* <Grid item xs={8} className={classes.messagessWrapper}> */}
            {ticketId ? (
              <>
                <Ticket />
              </>
            ) : (
              <Hidden only={["sm", "xs"]}>
                <Paper className={classes.welcomeMsg}>
                  {/* <Paper square variant="outlined" className={classes.welcomeMsg}> */}
                  <span>{i18n.t("chat.noTicketMessage")}</span>
                </Paper>
              </Hidden>
            )}
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default Chat;

